import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {FormComponent} from '../../core/base/form.component';
import {takeUntil} from 'rxjs/operators';
import {SubsidiesStore} from '../../services/subidies/subsidies.store';
import {getSubsidyConfig} from '../../subsidies.config';

@Component({
	selector: 'tvsub-subsidy-type-selector',
	templateUrl: './subsidy-type-selector.component.html',
	styleUrls: ['./subsidy-type-selector.component.scss'],
	standalone: false
})
export class SubsidyTypeSelectorComponent extends FormComponent implements OnInit {
	subsidyTypes = [
		{
			type: null,
			name: 'Toon alle subsidieaanvragen',
		},
		{
			type: 'ivv',
		},
		{
			type: 'jv',
		},
		{
			type: 'logies',
		},
		{
			type: 'nwb',
		},
		{
			type: 'ivv_sto',
		},
		{
			type: 'wo1',
		},
	];
	readonly getSubsidyConfig = getSubsidyConfig;

	constructor(private fb: UntypedFormBuilder, private subsidiesStore: SubsidiesStore) {
		super();
	}

	ngOnInit() {
		const selectedSubsidyType = this.subsidiesStore.selectedSubsidyType;

		this.form = this.fb.group({
			subsidyType: [selectedSubsidyType],
		});

		this.form
			.get('subsidyType')
			?.valueChanges.pipe(takeUntil(this.destroyed$))
			.subscribe((type) => {
				this.subsidiesStore.setSelectedSubsidyType(type);
			});
	}

	protected onInvalidForm() {}

	protected resetInvalidForm() {}
}
